var __webpack_error__ = new Error();
module.exports = new Promise(function(resolve, reject) {
	if(typeof ExternalComp !== "undefined") return resolve();
	__webpack_require__.l("https://65927825-micro-fe-dhl-w3promo.increso.it/MicroFrontendDhlPromoEntry.js", function(event) {
		if(typeof ExternalComp !== "undefined") return resolve();
		var errorType = event && (event.type === 'load' ? 'missing' : event.type);
		var realSrc = event && event.target && event.target.src;
		__webpack_error__.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		__webpack_error__.name = 'ScriptExternalLoadError';
		__webpack_error__.type = errorType;
		__webpack_error__.request = realSrc;
		reject(__webpack_error__);
	}, "ExternalComp");
}).then(function() { return ExternalComp; });